import { createFileRoute, redirect } from '@tanstack/react-router'
import { signInWithToken, takeUrlToken } from '@/lib/url-token'

// A game's Manage Account link: sign this browser in to the game's login, then show the account page.
// An invalid or expired token is ignored, leaving whatever login the browser already had.
export const Route = createFileRoute('/open-account')({
  beforeLoad: async ({ location }) => {
    const token = takeUrlToken(location)
    if (token) await signInWithToken(token)
    throw redirect({ to: '/account', replace: true })
  },
})
